import { Injectable } from '@angular/core';
import { decodeJwtPayload } from '@nebular/auth';
import * as moment from 'moment';


@Injectable()
export class JwtService {

  /**
   * Resets local storage from previously stored token
   */
  destroyToken(): void {
    window.localStorage.removeItem('jwtToken');
  }

  /**
   * Returns current token stored in local storage
   */
  getToken(): string {
    return window.localStorage['jwtToken'];
  }

  /**
   * Returns whether the current token is valid
   */
  isCurrentTokenValid(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }

    const exp = decodeJwtPayload(token).exp * 1000;

    return moment(exp).isAfter(new Date());
  }

  /**
   * Stores a new token in the local storage
   *
   * @param token
   */
  saveToken(token: string): void {
    window.localStorage['jwtToken'] = token;
  }

}
